module.exports = __webpack_public_path__ + "media/images/front/icon_case-6a087a4c293abbfdf2f8b351603e7a13.png";